module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_04"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ODE TO THE PLANTAR FASCIA")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("Latin cousin to Achilles,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("architectural upholder")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("bearing its magisterial bundle")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("beneath an imperial arch,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("rods around ax")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("around")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("axle and axis,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("staunch stanchion of the canonical self,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("aquiline and august,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("tensile, earthly, planted")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("and wound in sinewed plaits,")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("inverted hammock")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("on which the body rests its burden")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("like a red-faced tourist")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("in the shadow")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("of a coconut palm,")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("only now is your grievance")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("made known to me,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("only now do I hear your cry,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("unenviable membrane,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("faithful attendant upon my every stride,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("tender sole, antipodal to the soul,")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("pale mirror to the palm")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("of this hand,")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("only now do I honor your service,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("and my dignity is hobbled,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("only now do I learn to address you by name,")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("and the Empire")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("trembles.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a3386e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter04.vue
// module id = 81
// module chunks = 0